export default "__VITE_ASSET__2d4fcb6e__"